window.chartPlanungssimulationLiqui = {
	data: {
		liquiditaet_positiv: [],
		liquiditaet_negativ: [],
		erfolg: 0,
	},

	init() {
		this.chart = new Highcharts.stockChart("chart_planungssimulation_liquiditaet", {
			subtitle: {
				useHTML: true,
				align: "center",
				verticalAlign: "middle",
				style: {
					//fontWeight: 'bold',
					fontSize: "14px",
				},
				text: `<div style="text-align: center;"> Liquidität <br> ${this.data.erfolg}% </div>`,
			},

			tooltip: {
				enabled: false,
			},

			plotOptions: {
				pie: {
					size: 120,
					innerSize: "80%",
					states: {
						inactive: {
							opacity: 1,
						},
					},
					enableMouseTracking: false,
				},
			},

			series: this.series(),
		})
	},

	update() {
		if (!this.chart) return

		this.chart.showLoading()

		const seriesArrays = [this.series()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) s.setData(serie.data, false)
		})

		this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.hideLoading()
	},

	series() {
		return [
			{
				name: "Liquidität",
				id: "liquiditaet",
				type: "pie",
				data: [
					{
						y: this.data.liquiditaet_positiv,
						color: farbeEinnahmen,
					},
					{
						y: this.data.liquiditaet_negativ,
						color: farbeRot,
					},
				],
			},
		]
	},
}
